import React, { Component } from 'react';
import 'css/ViewOddsGroup.scss';
import { connect } from 'react-redux';
import ViewOddsButton from 'containers/ViewOddsButton';
import { ViewOddsDisabledButton } from './ViewButton';
import infoIcon from 'images/info.png';
import { NotificationManager } from 'react-notifications';

class ViewOddsGroup extends Component {
    render() {
        let view = null;
        const markets = this.props.data;

        if (markets) {
            const marketsSize = Object.keys(markets).length;

            if (marketsSize > 0) {
                view = [];

                let index = 0;

                for (let group of markets) {
                    view.push(
                        <OddsGroup
                            key={index}
                            group={group}
                            label={this.props.label}
                            popular={this.props.popular}
                            event={this.props.eventObject}
                        />
                    );
                    index++;
                }
            }
        }

        return <div className="view-odds-group">{view}</div>;
    }
}

class OddsGroup extends Component {
    constructor() {
        super();
        this.state = {
            widgetMarket: '',
        };
    }

    showInfo(text, e) {
        NotificationManager.warning('', text, 7000);
        e.stopPropagation();
        e.preventDefault();
    }

    getOddsView(itemList) {
        let oddsView = null;
        let className = 'col-33';
        let oddsCounter = 0;
        if (itemList && itemList.length === 1) {
            let item = itemList[0];

            oddsCounter = 1;

            oddsView = (
                <div>
                    {item.bet !== 'X' ? (
                        item.odds !== 1 ? (
                            <ViewOddsButton
                                onClickHandler={this.onOddsClickHandler.bind(
                                    this
                                )}
                                item={item}
                                market={this.props.group}
                            />
                        ) : (
                            <ViewOddsDisabledButton>-</ViewOddsDisabledButton>
                        )
                    ) : item.odds !== 1 ? (
                        <ViewOddsButton
                            onClickHandler={this.onOddsClickHandler.bind(this)}
                            item={item}
                            market={this.props.group}
                        />
                    ) : null}
                </div>
            );
        } else if (
            itemList &&
            itemList.length === 3 &&
            itemList.every((bet) => bet.odds > 1) &&
            itemList[1] &&
            itemList[1].bet !== 'X'
        ) {
            oddsView = itemList.map((item, index) => {
                oddsCounter++;

                return (
                    <div className="col-33" key={index}>
                        {item.odds !== 1 ? (
                            <ViewOddsButton
                                onClickHandler={this.onOddsClickHandler.bind(
                                    this
                                )}
                                item={item}
                                market={this.props.group}
                            />
                        ) : (
                            <ViewOddsDisabledButton>-</ViewOddsDisabledButton>
                        )}
                    </div>
                );
            });
        } else if (
            itemList &&
            (itemList.length <= 3 ||
                (itemList.length === 3 &&
                    !itemList.every((bet) => bet.odds > 1)))
        ) {
            if (itemList && itemList.length === 2) {
                className = 'col-5';
            } else if (
                (itemList[1] &&
                    itemList[1].bet &&
                    itemList[1].bet === 'X' &&
                    itemList[1].odds === 1) ||
                (itemList[1] && itemList[1].bet && itemList[1].bet !== 'X') ||
                (itemList[2] &&
                    itemList[2].bet &&
                    itemList[2].bet === '2' &&
                    itemList[2].odds === 1) ||
                (itemList[0] &&
                    itemList[0].bet &&
                    itemList[0].bet === '1' &&
                    itemList[0].odds === 1)
            ) {
                className = 'col-5';
            }

            oddsView = itemList.map((item, index) => {
                oddsCounter++;

                return (
                    <div className={className} key={index}>
                        <ViewOddsButton
                            onClickHandler={this.onOddsClickHandler.bind(this)}
                            item={item}
                            market={this.props.group}
                        />
                    </div>
                );
            });
        } else {
            if (this.props.group.marketName.indexOf('Ciffertip') === -1) {
                let isHomeDrawAway = itemList.some((el) => {
                    return String(el.homeDrawAway).toLowerCase() === 'x';
                });
                if (
                    itemList.every(
                        (el) =>
                            String(el.homeDrawAway) === itemList[0].homeDrawAway
                    )
                ) {
                    oddsView = (
                        <div className="row">
                            {itemList.map((item, index) => {
                                oddsCounter++;
                                return (
                                    <div className={'col-5'} key={item.betNr}>
                                        <ViewOddsButton
                                            key={index}
                                            onClickHandler={this.onOddsClickHandler.bind(
                                                this
                                            )}
                                            item={item}
                                            market={this.props.group}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    );
                } else {
                    oddsView = (
                        <div className="row">
                            <div
                                className={isHomeDrawAway ? 'col-33' : 'col-5'}
                            >
                                {itemList.map((item, index) => {
                                    oddsCounter++;
                                    return item.homeDrawAway === '1' ? (
                                        <ViewOddsButton
                                            key={index}
                                            onClickHandler={this.onOddsClickHandler.bind(
                                                this
                                            )}
                                            item={item}
                                            market={this.props.group}
                                        />
                                    ) : null;
                                })}
                            </div>
                            {isHomeDrawAway ? (
                                <div className={'col-33'}>
                                    {itemList.map((item, index) => {
                                        oddsCounter++;

                                        return item.homeDrawAway === 'X' ? (
                                            <ViewOddsButton
                                                key={index}
                                                onClickHandler={this.onOddsClickHandler.bind(
                                                    this
                                                )}
                                                item={item}
                                                market={this.props.group}
                                            />
                                        ) : null;
                                    })}
                                </div>
                            ) : null}

                            <div
                                className={isHomeDrawAway ? 'col-33' : 'col-5'}
                            >
                                {itemList.map((item, index) => {
                                    oddsCounter++;

                                    return item.homeDrawAway === '2' ? (
                                        <ViewOddsButton
                                            key={index}
                                            onClickHandler={this.onOddsClickHandler.bind(
                                                this
                                            )}
                                            item={item}
                                            market={this.props.group}
                                        />
                                    ) : null;
                                })}
                            </div>

                            <div className="row">
                                {itemList.map((item, index) => {
                                    oddsCounter++;

                                    return item.homeDrawAway === null ||
                                        item.homeDrawAway === undefined ? (
                                        <div className="col-5" key={index}>
                                            <ViewOddsButton
                                                onClickHandler={this.onOddsClickHandler.bind(
                                                    this
                                                )}
                                                item={item}
                                                market={this.props.group}
                                            />
                                        </div>
                                    ) : null;
                                })}
                            </div>
                        </div>
                    );
                }
            } else {
                if (
                    this.props.group.marketTypeName !== 'HT/FT - Ciffertip' &&
                    itemList[0].homeDrawAway
                ) {
                    oddsView = (
                        <div className="row">
                            <div className="col-33">
                                {itemList.map((item, index) => {
                                    oddsCounter++;

                                    return item.homeDrawAway === '1' ? (
                                        <ViewOddsButton
                                            key={index}
                                            onClickHandler={this.onOddsClickHandler.bind(
                                                this
                                            )}
                                            item={item}
                                            market={this.props.group}
                                        />
                                    ) : null;
                                })}
                            </div>
                            <div className="col-33">
                                {itemList.map((item, index) => {
                                    oddsCounter++;

                                    return item.homeDrawAway === 'X' ? (
                                        <ViewOddsButton
                                            key={index}
                                            onClickHandler={this.onOddsClickHandler.bind(
                                                this
                                            )}
                                            item={item}
                                            market={this.props.group}
                                        />
                                    ) : null;
                                })}
                            </div>
                            <div className="col-33">
                                {itemList.map((item, index) => {
                                    oddsCounter++;

                                    return item.homeDrawAway === '2' ? (
                                        <ViewOddsButton
                                            key={index}
                                            onClickHandler={this.onOddsClickHandler.bind(
                                                this
                                            )}
                                            item={item}
                                            market={this.props.group}
                                        />
                                    ) : null;
                                })}
                            </div>
                        </div>
                    );
                } else {
                    oddsView = (
                        <div className="row">
                            {itemList.map((item, index) => {
                                oddsCounter++;

                                return (
                                    <div className="col-5" key={index}>
                                        <ViewOddsButton
                                            onClickHandler={this.onOddsClickHandler.bind(
                                                this
                                            )}
                                            item={item}
                                            market={this.props.group}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    );
                }
            }
        }
        if (
            oddsCounter > 0 &&
            this.props.group.itemList.some((bet) => bet.odds > 1)
        ) {
            return (
                <section className="view-odds-group-container">
                    {!this.props.group.noHeader || this.props.popular ? (
                        <div className="row">
                            <div className="col-8">
                                <h5 className="group-label">
                                    {this.props.group.marketName}
                                </h5>
                                {this.props.group.freeText ? (
                                    <img
                                        src={infoIcon}
                                        className="mv10 cursor-pointer"
                                        onClick={this.showInfo.bind(
                                            this,
                                            this.props.group.freeText
                                        )}
                                        height="16px"
                                        alt="ingo"
                                    />
                                ) : null}
                            </div>
                        </div>
                    ) : null}

                    <div className="row odds-row">{oddsView}</div>
                </section>
            );
        } else {
            return null;
        }
    }

    onOddsClickHandler() {
        console.log('onOddsClickHandler');
    }

    render() {
        if (this.props.group) {
            const itemList = this.props.group.itemList;

            return this.getOddsView(itemList);
        } else {
            return null;
        }
    }
}

const mapStateToProps = (state) => ({ eventObject: state.eventObject });

export default connect(
    mapStateToProps,
    null
)(ViewOddsGroup);
